import { indexes } from '@mab-common/utils'

import type { TradingFloorItemProps } from '~/components/blocks/TradingFloorList/TradingFloorList'
import { useElasticQuery } from '~/services/query/use-elastic-query'
import RecordTypes = indexes.RecordTypes
import EsIndexTypes = indexes.EsIndexTypes
import { buildElasticSortFields } from '../elastic/builder'

export default function useLatestTrading() {
  return useElasticQuery<TradingFloorItemProps>(RecordTypes.TICKETS, {
    index: EsIndexTypes.TICKETS,
    searches: [
      {},
      {
        from: 0,
        size: 5,
        sort: buildElasticSortFields(RecordTypes.TICKETS),
      },
    ],
  })
}
